import { authenticatedService } from '@/interfaces/authenticatedService'

const logoutService = authenticatedService('/logout')

const logout = logoutService.remove

logoutService.setServiceMethods({ logout })

export const logoutDomain = logoutService.initialize
